import { Navigate } from "react-router-dom";
import { useAuth } from "../services/authService";
import {
  normalizeStatus,
  normalizeRole,
  canDownloadClientDocs,
} from "../services/authz";

export default function ClientRoute({ children }) {
  const { currentUser, userStatus, userRole } = useAuth();

  if (!currentUser) return <Navigate to="/login" replace />;

  const status = normalizeStatus(userStatus);
  const role = normalizeRole(userRole);

  const allowed = canDownloadClientDocs(status, role); // super_admin + client_admin + client_user
  if (!allowed) return <Navigate to="/firmware" replace />;

  return children;
}
